import React from 'react';
import styles from './Backdrop.scss';

const backdrop = (props) => (
    props.show ? <div 
                    className={styles.Backdrop}
                    onClick={props.clicked}>
                 </div> : null
);

export default backdrop;


// WEBPACK FOOTER //
// ./src/components/presentational/Backdrop/Backdrop.js